export var copyToClipboard = function copyToClipboard(value) {
  var elementToCopy = document.createElement('textarea');
  elementToCopy.innerText = value;
  document.body.appendChild(elementToCopy);
  elementToCopy.select();
  document.execCommand('copy');
  elementToCopy.remove();
};